import { Network } from '@shared/types'
import { IS_TESTNET } from '@shared/utils/constant'
import { CosmosChainId } from '@injectivelabs/ts-types'

export const networkMetaMapping: Record<
  string,
  { logo: string; display: string }
> = {
  [Network.Injective]: {
    display: 'Injective',
    logo: '/network/injective-v4.webp'
  },
  [Network.Ethereum]: {
    display: 'Ethereum',
    logo: '/network/ethereum.png'
  },
  [Network.EthereumWh]: {
    display: 'Ethereum (Wormhole)',
    logo: '/network/ethereumWh.svg'
  },
  [Network.CosmosHub]: {
    display: 'CosmosHub',
    logo: '/network/cosmosHub.png'
  },
  [Network.CosmosHubTestnet]: {
    display: 'CosmosHub Testnet',
    logo: '/network/cosmosHub.png'
  },
  [Network.Solana]: {
    display: 'Solana',
    logo: '/network/solana.svg'
  },
  [Network.Polygon]: {
    display: 'Polygon',
    logo: '/network/polygon.png'
  },
  [Network.Osmosis]: {
    display: 'Osmosis',
    logo: '/network/osmosis.png'
  },
  [Network.Persistence]: {
    display: 'Persistence',
    logo: '/network/persistence.png'
  },
  [Network.Evmos]: {
    display: 'Evmos',
    logo: '/network/evmos.png'
  },
  [Network.EvmosTestnet]: {
    display: 'Evmos Testnet',
    logo: '/network/evmos.png'
  },
  [Network.Axelar]: {
    display: 'Axelar',
    logo: '/network/axelar.svg'
  },
  [Network.Secret]: {
    display: 'Secret Network',
    logo: '/network/secret.png'
  },
  [Network.Stride]: {
    display: 'Stride',
    logo: '/network/stride.png'
  },
  [Network.Crescent]: {
    display: 'Crescent',
    logo: '/network/crescent.jpeg'
  },
  [Network.Sommelier]: {
    display: 'Sommelier',
    logo: '/network/sommelier.png'
  },
  [Network.Arbitrum]: {
    display: 'Arbitrum',
    logo: '/network/arbitrum-circle.png'
  },
  [Network.Oraichain]: {
    display: 'Oraichain',
    logo: '/network/orai.svg'
  },
  [Network.Kava]: {
    display: 'Kava',
    logo: '/network/kava.webp'
  },
  [Network.Celestia]: {
    display: 'Celestia',
    logo: '/network/celestia.webp'
  },
  [Network.Kujira]: {
    display: 'Kujira',
    logo: '/network/kujira.webp'
  },
  [Network.Migaloo]: {
    display: 'Migaloo',
    logo: '/network/migaloo.svg'
  },
  [Network.Andromeda]: {
    display: 'Andromeda',
    logo: '/network/andromeda.webp'
  },
  [Network.Noble]: {
    display: 'Noble',
    logo: '/network/noble.webp'
  },
  [Network.Saga]: {
    display: 'Saga',
    logo: '/network/saga.webp'
  },
  [Network.XionTestnet]: {
    display: 'Xion Testnet',
    logo: '/network/xion.png'
  },
  [Network.Fetch]: {
    display: 'Fetch',
    logo: '/network/fetch.png'
  },
  [Network.Mantra]: {
    display: 'Mantra',
    logo: '/network/om.webp'
  },
  [Network.WormholeGeneric]: {
    display: 'Wormhole Generic',
    logo: '/network/wh.jpeg'
  },
  [Network.Xion]: {
    display: 'Xion',
    logo: '/network/xion.png'
  }
}

export const networkTokensMapping: Record<string, string[]> = {
  [Network.CosmosHub]: [
    'ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9' // ATOM
  ],
  [Network.Osmosis]: [
    'inj',
    'ibc/92E0120F15D037353CFB73C14651FC8930ADC05B93100FD7754D3A689E53B333' // OSMO
  ],
  [Network.Chihuahua]: [
    'ibc/E7807A46C0B7B44B350DA58F51F278881B863EC4DCA94635DAB39E52C30766CB' // HUAHUA
  ],
  [Network.Axelar]: [
    'ibc/B68C1D2682A8B69E20BB921E34C6A3A2B6D1E13E3E8C0092E373826F546DEE65' // AXL
  ],
  [Network.Juno]: [
    'ibc/D50E26996253EBAA8C684B9CD653FE2F7665D7BDDCA3D48D5E1378CF6334F211' // JUNO
  ],
  [Network.Evmos]: [
    'ibc/16618B7F7AC551F48C057A13F4CA5503693FBFF507719A85BC6876B8BD75F821', // EVMOS
    'ibc/F6CC233E5C0EA36B1F74AB1AF98471A2D6A80E2542856639703E908B4D93E7C4' // NEOK
  ],
  [Network.Persistence]: [
    'ibc/B786E7CBBF026F6F15A8DA248E0F18C62A0F7A70CB2DABD9239398C8B5150ABB' // XPRT
  ],
  [Network.Secret]: [
    'ibc/0954E1C28EB7AF5B72D24F3BC2B47BBB2FDF91BDDFD57B74B99E133AED40972A' // SCRT
  ],
  [Network.Stride]: [
    'inj',
    'ibc/3FDD002A3A4019B05A33D324B2F29748E77AF501BEA5C96D1F28B2D6755F9F25', // STRD
    'ibc/AC87717EA002B0123B10A05063E69BCA274BA2C44D842AEEB41558D2856DCE93' // STINJ
  ],
  [Network.Crescent]: [
    'inj',
    'ibc/3A6DD3358D9F7ADD18CDE79BA10B400511A5DE4AE2C037D7C9639B52ADAF35C6' // CRE
  ],
  [Network.Sommelier]: [
    'ibc/34346A60A95EB030D62D6F5BDD4B745BE18E8A693372A8A347D5D53DBBB1328B' // SOMM
  ],
  [Network.Canto]: [
    'ibc/D91A2C4EE7CD86BBAFCE0FA44A60DDD9AFBB7EEB5B2D46C0984DEBCC6FEDFAE8' // CANTO
  ],
  [Network.Kava]: [
    'ibc/57AA1A70A4BC9769C525EBF6386F7A21536E04A79D62E1981EFCEF9428EBB205', // KAVA
    'ibc/4ABBEF4C8926DDDB320AE5188CFD63267ABBCEFC0583E4AE05D6E5AA2401DDAB' // USDTkv
  ],
  [Network.Oraichain]: [
    'ibc/C20C0A822BD22B2CEF0D067400FCCFB6FAEEE9E91D360B4E0725BD522302D565' // ORAI
  ],
  [Network.CosmosHubTestnet]: [
    'ibc/48BC9C6ACBDFC1EBA034F1859245D53EA4BF74147189D66F27C23BF966335DFB' // UPHOTON [TESTNET]
  ],
  [Network.Noble]: [
    'ibc/2CBC2EA121AE42563B08028466F37B600F2D7D4282342DE938283CC3FB2BC00E', // USDC
    'ibc/93EAE5F9D6C14BFAC8DD1AFDBE95501055A7B22C5D8FA8C986C31D6EFADCA8A9' // USDY
  ],
  [Network.Celestia]: [
    'ibc/F51BB221BAA275F2EBF654F70B005627D7E713AFFD6D86AFD1E43CAA886149F4' // TIA
  ],
  [Network.Migaloo]: [
    'inj',
    'ibc/D6E6A20ABDD600742D22464340A7701558027759CE14D12590F8EA869CCCF445' // WHALE
  ],
  [Network.Kujira]: [
    'ibc/9A115B56E769B92621FFF90567E2D60EFD146E86E867491DB69EEDA9ADC36204' // KUJI
  ],
  [Network.Andromeda]: [
    'ibc/61FA42C3F0B0F8768ED2CE380EDD3BE0E4CB7E67688F81F70DE9ECF5F8684E1E' // ANDR
  ],
  [Network.Saga]: [
    'ibc/AF921F0874131B56897A11AA3F33D5B29CD9C147A1D7C37FE8D918CB420956B2' // SAGA
  ],
  [Network.XionTestnet]: [
    'ibc/00BF66BAB34873B07FB9EEEBCFACEA11FB4BB348718862AA7782D6DECC1F44C8' // XION [TESTNET]
  ],
  [Network.Fetch]: [
    'ibc/C1D3666F27EA64209584F18BC79648E0C1783BB6EEC04A8060E4A8E9881C841B' // FET
  ],
  [Network.Mantra]: [
    'ibc/775AB5A9D31074F245BB7864B7031AC7BDC9C6C0FD64A72528A8D07203CD71F3' // OM
  ],
  [Network.Xion]: [
    'ibc/00BF66BAB34873B07FB9EEEBCFACEA11FB4BB348718862AA7782D6DECC1F44C8' // XION
  ],
  [Network.Ethereum]: [],
  [Network.EvmosTestnet]: [
    'ibc/300B5A980CA53175DBAC918907B47A2885CADD17042AD58209E777217D64AF20' // TEVMOS
  ]
}

export const PEGGY_NETWORKS = [Network.Ethereum] as Network[]

export const EVM_WORMHOLE_NETWORKS = [
  Network.EthereumWh,
  Network.Polygon,
  Network.Arbitrum,
  Network.Klaytn
] as Network[]

export const COSMOS_NETWORKS = [
  Network.XionTestnet,
  Network.Oraichain,
  Network.Kava,
  Network.Celestia,
  Network.Kujira,
  Network.CosmosHub,
  Network.Osmosis,
  Network.Persistence,
  Network.Evmos,
  Network.Axelar,
  Network.Secret,
  Network.Stride,
  Network.Crescent,
  Network.Sommelier,
  Network.Migaloo,
  Network.CosmosHubTestnet,
  Network.Andromeda,
  Network.Noble,
  Network.Saga,
  Network.Mantra,
  Network.EvmosTestnet,
  Network.Fetch,
  Network.Xion
] as Network[]

export const WORMHOLE_NETWORKS = [
  Network.Solana,
  ...EVM_WORMHOLE_NETWORKS
] as Network[]

// determines UI network selector sorting
export const NETWORKS = IS_TESTNET
  ? ([
      Network.Solana,
      Network.XionTestnet,
      Network.CosmosHubTestnet,
      Network.Ethereum,
      Network.EthereumWh,
      Network.EvmosTestnet,
      Network.CosmosHubTestnet
    ] as Network[])
  : ([
      Network.Ethereum, // Eth
      Network.Noble,
      Network.Celestia,
      Network.Solana, // Phantom
      Network.CosmosHub,
      Network.Andromeda,
      Network.Arbitrum, // Eth layer 2
      Network.Axelar,
      Network.Crescent,
      Network.EthereumWh, // Eth
      Network.Evmos,
      Network.Kava,
      Network.Kujira,
      Network.Migaloo,
      Network.Oraichain,
      Network.Osmosis,
      Network.Persistence,
      Network.Polygon,
      Network.Secret,
      Network.Sommelier,
      Network.Stride,
      Network.Saga,
      Network.Mantra,
      Network.Fetch,
      Network.Xion
    ] as Network[])

// networks that dont support the memo field
export const oldIbcVersionNetworks = [Network.Fetch] as Network[]
export const oldIbcVersionNetworksByChainId = [
  CosmosChainId.Fetch
] as CosmosChainId[]
